import React from "react";
import {
  Badge,
  DateRange,
  Devices,
  ErrorOutline,
  Fingerprint,
  Schedule,
  SwapHoriz,
  Tag,
  Timeline,
} from "@mui/icons-material";

export const PunchProcessingExceptionsHeader = [
  { key: "employee_label", name: "Employee", type: "string", icon: <Badge fontSize="small" /> },
  { key: "punch_date_display", name: "Punch Entry Date", type: "string", icon: <DateRange fontSize="small" /> },
  { key: "punch_time", name: "Punch Entry Time", type: "string", icon: <Schedule fontSize="small" /> },
  { key: "direction", name: "Direction", type: "string", icon: <SwapHoriz fontSize="small" /> },
  { key: "device_label", name: "Device", type: "string", icon: <Devices fontSize="small" /> },
  { key: "issue", name: "Issue", type: "string", icon: <ErrorOutline fontSize="small" /> },
  { key: "processing_stage", name: "Processing Stage", type: "string", icon: <Timeline fontSize="small" /> },
  { key: "event_time", name: "Event Time", type: "string", icon: <Fingerprint fontSize="small" /> },
  { key: "event_id", name: "Event ID", type: "string", icon: <Tag fontSize="small" /> },
];
